var _path, _rect, _path2, _path3, _path4, _path5, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHinava3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hinava_random_uuid_89974943174729097123368774220324977908)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hinava_random_uuid_15123170833680973824186548996760539494",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#hinava_random_uuid_15123170833680973824186548996760539494)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6508 9.77458C17.6401 9.77458 17.6295 9.77458 17.6189 9.77192C17.3772 9.75599 17.1967 9.54355 17.2126 9.30189C17.2418 8.91949 17.1011 8.54506 16.8302 8.2742C16.5593 8.00333 16.1849 7.86524 15.8025 7.89445C15.5609 7.91039 15.3511 7.72981 15.3325 7.48815C15.3139 7.2465 15.4971 7.03671 15.7388 7.01812C16.3734 6.97032 16.9975 7.20401 17.4489 7.6528C17.9004 8.10424 18.1314 8.72829 18.0863 9.36297C18.0703 9.59931 17.8791 9.77458 17.6508 9.77458Z",
    fill: "#23D4FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3211 9.20636C19.3105 9.20636 19.2998 9.20636 19.2866 9.2037C19.0449 9.18511 18.8643 8.97532 18.8803 8.73367C18.9307 8.05385 18.6838 7.38731 18.2004 6.904C17.7171 6.42334 17.0533 6.17372 16.3734 6.22418C16.1318 6.24011 15.922 6.05953 15.9034 5.81788C15.8848 5.57622 16.0654 5.36644 16.3097 5.34785C17.2445 5.2788 18.1606 5.61871 18.8245 6.27994C19.4884 6.94117 19.8283 7.85999 19.7566 8.79475C19.7407 9.03109 19.5495 9.20636 19.3211 9.20636Z",
    fill: "#23D4FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9626 14.3023V18.4848C18.9626 18.769 18.7315 19 18.4474 19H14.5677C14.2835 19 14.0525 18.769 14.0525 18.4848V14.6051C14.0525 14.3209 13.8241 14.0925 13.5373 14.0925H9.66023C9.37609 14.0925 9.14506 14.3209 9.14506 14.6051V18.4848C9.14506 18.769 8.91403 19 8.62989 19H4.75016C4.46602 19 4.23499 18.769 4.23499 18.4848V9.39488C4.23499 9.2568 4.2881 9.12667 4.38635 9.03107L8.26608 5.15132C8.59006 4.82734 9.14241 5.05837 9.14241 5.51513V8.66726C9.14241 8.95141 9.37344 9.18244 9.65758 9.18244H13.8374C13.9728 9.18244 14.1056 9.23821 14.2012 9.33381L18.8085 13.9412C18.851 13.9837 18.8882 14.0368 18.9121 14.0925C18.944 14.1563 18.9626 14.228 18.9626 14.3023Z",
    fill: "#23D4FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "hinava_random_uuid_162119634313678297328961852975865278045",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 8,
    width: 10,
    height: 7
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12912 14.5945C9.12912 14.3103 9.36015 14.0793 9.64429 14.0793H18.9015C18.8776 14.0235 18.8404 13.9731 18.7979 13.9279L14.1879 9.32319C14.0923 9.22759 13.9595 9.17182 13.8241 9.17182H9.64164C9.3575 9.17182 9.12646 8.94079 9.12646 8.65665V14.5945H9.12912Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#hinava_random_uuid_162119634313678297328961852975865278045)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8987 8.65665H9.12903V14.5945H18.8987V8.65665Z",
    fill: "#23D4FF"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "hinava_random_uuid_89974943174729097123368774220324977908"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHinava3);
export default __webpack_public_path__ + "static/media/hinava3.804bee338c9f9864a60a0b84876d5f06.svg";
export { ForwardRef as ReactComponent };